import script from "./GeneralProductInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./GeneralProductInformation.vue?vue&type=script&setup=true&lang=ts"

import "./GeneralProductInformation.vue?vue&type=style&index=0&id=7ad2a6ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad2a6ec"]])

export default __exports__